import { Outlet } from 'react-router-dom';

import { HeaderPage } from 'components/header/HeaderPage';
import { Row } from 'enable-ui';

import { useAdminLayoutController } from '../core/controller/admin-layout';

export const AdminLayout = () => {
  const { onClickAdd, isSuperAdmin } = useAdminLayoutController();

  return (
    <Row direction="column" style={{ maxWidth: 1200 }}>
      <HeaderPage title="Admin users" onClick={onClickAdd} hideButton={!isSuperAdmin} />
      <Outlet />
    </Row>
  );
};
